import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [userClients, setUserClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);

  useEffect(() => {
    const initializeAuth = async () => {
      const storedUser = localStorage.getItem('user');
      const storedToken = localStorage.getItem('token');
      const storedSelectedClient = localStorage.getItem('selectedClient');

      if (storedUser && storedToken) {
        const parsedUser = JSON.parse(storedUser);
        setUser(parsedUser);
        axios.defaults.headers.common['Authorization'] = `Bearer ${storedToken}`;

        if (storedSelectedClient) {
          setSelectedClient(JSON.parse(storedSelectedClient));
        }

        await fetchUserClients(parsedUser.id);
      }

      setLoading(false);
    };

    initializeAuth();
  }, []);

  useEffect(() => {
    if (userClients.length > 0 && !selectedClient) {
      const storedSelectedClient = localStorage.getItem('selectedClient');
      if (storedSelectedClient) {
        setSelectedClient(JSON.parse(storedSelectedClient));
      } else {
        selectClient(userClients[0]);
      }
    }
  }, [userClients, selectedClient]);

  const fetchUserClients = async (userId) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/user_clients/user/${userId}`);
      setUserClients(response.data);
    } catch (error) {
      console.error('Erro ao buscar clientes do usuário:', error);
    }
  };

  const selectClient = (client) => {
    setSelectedClient(client);
    localStorage.setItem('selectedClient', JSON.stringify(client));
  };

  const login = async (email, password) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/users/login`, {
        dsemail: email,
        dspassword: password
      });

      const { token, user } = response.data;

      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));

      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      setUser(user);

      await fetchUserClients(user.id);

      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Erro ao fazer login'
      };
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('selectedClient');
    delete axios.defaults.headers.common['Authorization'];
    setUser(null);
    setUserClients([]);
    setSelectedClient(null);
  };

  return (
    <AuthContext.Provider value={{
      user,
      login,
      logout,
      loading,
      userClients,
      selectedClient,
      selectClient
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
